import { Data, TransformsList } from 'cio/utils/analytics/transforms';

const Transforms: TransformsList = {
  base(data: Data) {
    return {
      'Collection ID': data?.model?.id,
      'Collection Size': data?.model?.rows,
    };
  },
};

export default Transforms;
